type Client = typeof import("@/integrations/supabase/client")["supabase"];

/**
 * Loads the generated Supabase client on demand.
 *
 * The client (plus realtime + auth) is ~55 KB gzipped. Importing it statically
 * from the auth/entitlement/presence providers pulled it into the initial
 * critical path of every page, including public marketing pages that never
 * talk to the backend before hydration. Loading it from an effect keeps first
 * paint free of that work without changing behaviour: every caller still gets
 * the exact same singleton client.
 */
let clientPromise: Promise<Client> | null = null;

export function getSupabase(): Promise<Client> {
  clientPromise ??= import("@/integrations/supabase/client").then((m) => m.supabase);
  return clientPromise;
}
